<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <!-- test select -->
              <v-col class="pt-0 " cols="12" md="12">
              <h2>{{ getInJournalName }}</h2>
              <v-divider class="mt-3"></v-divider>
            </v-col>
            <!-- message-details -->
            <v-col
              v-if="showComponents('MessageDetails', formData.in_journal_type)"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="MessageDetails"
                title="Pranešimo duomenys"
              />
                <message-details
                  v-show="showCards['MessageDetails']"
                  :is-errors-correction="isErrorsCorrection"
                  :formData="formData"
                  :onlyView="editStatus"
                />
              <v-divider class="mt-3"></v-divider>
            </v-col>
            <!-- Data Provider -->
            <v-col
              v-if="showComponents('DataProvider', formData.in_journal_type)"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="DataProvider"
                title="Duomenų teikėjas"
              />
              <data-provider
              v-if="!pageloading"
                v-show="showCards['DataProvider']"
                :formData="formData.institution"
                :dataProviderType="formData.data_provider_type"
                :in-journal-type="formData.in_journal_type"
                :list="listOfIntitutions"
                :onlyView="editStatus"
                @setDataProvider="setDataProvider"
              />
              <v-divider class="mt-5"></v-divider>
            </v-col>
            <!-- subdelegatedDetails -->
             <v-col
              v-if="showSubdelegatedDetails"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="subdelegatedDetails"
                title="Duomenys apie įgaliojimą, kuris buvo perįgaliotas"
              />
                <v-row  v-show="showCards['subdelegatedDetails']">
                  <v-col class="pb-0 pt-0" cols="12" md="6">
                    <el-text-field
                      disabled
                      label="Įgaliojimo (tėvinio) identifikavimo kodas"
                      v-model="formData.mandate.parent.mandate_code"
                      :maxlength="200"
                    />
                  </v-col>
                  <v-col class="pb-0 pt-0" cols="12" md="6">
                    <el-checkbox
                      disabled
                      class="mt-0 mb-1"
                      style="width: fit-content"
                      label="Įgaliojimas, duotas perįgaliojant"
                      v-model="isSubmandateComp"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="formData.in_journal_type == '401' && formData.mandate.parent.suspension_date">
                  <v-col class="pt-0 ml-1" cols="12">
                    <h3 class="text-red">{{ $t(`Įgaliojimo tėvinis įgaliojimas yra sustabdytas - objekto ID ${this.formData.mandate.parent.mandate_code}`) }}</h3>
                  </v-col>
                </v-row>
                <v-divider class="mt-3"></v-divider>
            </v-col>
            <!-- Provided Data -->
            <v-col
              v-if="showComponents('ObjectData', formData.in_journal_type)"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="ObjectData"
                :title="getObjectDataTitle"
              />
              <mandate-data
                v-show="showCards['ObjectData']"
                :formData="formData.mandate"
                :inJournalType="formData.in_journal_type"
                :inJournalStatus="formData.status"
                :onlyView="editStatus"
                :isSubmandate="isSubmandate"
              />
              <v-divider class="mt-3"></v-divider>
            </v-col>

            <!-- Patvirtinęs notaras -->
            <v-col class="pt-0" cols="12" v-if="showComponents('ConfirmPerson', formData.in_journal_type) && ((formData.mandate.kind == 'NTPI' || formData.mandate.mandate_kind == 'NTPI') || formData.in_journal_type == '401')">
              <expand-form
                :showCards="showCards"
                name="ConfirmPerson"
                title="Įgaliojimą patvirtinusio notaro, konsulinio pareigūno ar kito asmens, turinčio teisę atlikti notarinius veiksmus, duomenys"
              />
              <v-row v-show="showCards['ConfirmPerson']">
                <v-col class="pb-0 pt-0" cols="6" v-if="confirmPersonEditable">
                  <el-autocomplete
                    direct
                    required
                    :items="confirmPersons"
                    itemvalue="value"
                    itemtext="text"
                    label="Patvirtinęs asmuo"
                    v-model="formData.mandate.confirm_person_id"
                    @change="toggleConfirmPerson"
                  />
                </v-col>
                <v-col cols="4" v-if="confirmPersonEditable">
                  <el-button
                    class="mb-3"
                    small
                    color="primary"
                    icon="pridėti"
                    title="Pridėti kitą asmenį"
                    :loading="loading"
                    @click.native.stop="openAddConfirmPersonModal()"
                  />
                </v-col>
                <v-col cols="12" >
                  <el-simple-table :items="[
                    {
                      title: 'Patvirtinusio asmens pareigos, vardas ir pavardė',
                      value: (formData.mandate.confirm_person_position || '') + ( formData.mandate.confirm_person_position ? ', ' : '') + (formData.mandate.confirm_person_fullname || ''),
                    },
                    {
                      title: 'Patvirtinusio asmens institucijos pavadinimas',
                      value: (formData.mandate.confirm_person_institution || ''),
                    },
                  ]" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12"><v-divider/></v-col>
              </v-row>
            </v-col>

            <!-- Principals Form -->
            <v-col
              v-if="showComponents('Principals', formData.in_journal_type)"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="Principals"
                :title="getPrincipalsTitle"
              />
              <principals-form
                v-show="showCards['Principals']"
                :persons="getPrincipals"
                :allowAdd="allowAddPerson"
                :onlyView="editStatus"
                :canEditContacts="canEditContacts"
                :allowForeignJur="allowForeignJur"
                :showTogether="true"
                :mandateData="formData.mandate"
                :isSubmandate="isSubmandate"
                :inJournalType="formData.in_journal_type"
              />
              <v-divider class="mt-3"></v-divider>
            </v-col>
            <!-- Representitives Form -->
            <v-col
              v-if="showComponents('Representitives', formData.in_journal_type)"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="Representitives"
                :title="getRepresentitivesTitle"
              />
              <representitives-form
                v-show="showCards['Representitives']"
                :persons="getRepresentitives"
                :tableKey="getTableKey"
                :allowAdd="allowAddPerson"
                :onlyView="editStatus"
                :canEditContacts="canEditContacts"
                :allowForeignJur="allowForeignJur"
                :showTogether="true"
                :mandateData="formData.mandate"
                :isSubmandate="isSubmandate"
                :inJournalType="formData.in_journal_type"
              />
              <v-divider class="mt-3"></v-divider>
            </v-col>
            <!-- RecognizedAsMissing -->
            <v-col
              v-if="showComponents('RecognizedAsMissing', formData.in_journal_type)"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="RecognizedAsMissing"
                title="Asmens, kuris yra pripažintas nežinia kur esančiu, duomenys"
              />
              <recognized-as-missing
                v-show="showCards['RecognizedAsMissing']"
                :person="formData.person"
                :onlyView="editStatus"
              />
              <v-divider class="mt-5"></v-divider>
            </v-col>
            <!-- List of objects -->
            <v-col
              v-if="showComponents('ObjectList', formData.in_journal_type)"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="ObjectList"
                title="Įgaliojimų / prokūrų duomenys"
              />
              <object-list
                v-show="showCards['ObjectList']"
                :mandates="formData.mandates"
              />
              <v-divider class="mt-5"></v-divider>
            </v-col>
            <!-- Court Data Form -->
            <v-col
              v-if="showComponents('ProvidedDataForm', formData.in_journal_type)"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="ProvidedDataForm"
                :title="getProvidedDataTitle"
              />
              <provided-data-form
                v-show="showCards['ProvidedDataForm']"
                :formData="formData.providedData"
                :mandateData="formData.mandate"
                :inJournalType="formData.in_journal_type"
                :onlyView="editStatus"
              />
              <v-divider class="mt-5"></v-divider>
            </v-col>
            <!-- Power Of Attorney Change Data -->
            <v-col
              v-if="showComponents('PowerOfAttorneyChangeData', formData.in_journal_type)"
              class="pt-0"
              cols="12"
            >
              <expand-form
                :showCards="showCards"
                name="PowerOfAttorneyChangeData"
                title="Įgaliojimo pakeitimo duomenys"
              />
              <mandate-change-data
                v-show="showCards['PowerOfAttorneyChangeData']"
                :formData="formData"
                :onlyView="editStatus"
              />
              <v-divider class="mt-3"></v-divider>
            </v-col>
            <!-- Patvirtinęs notaras -->
            <v-col class="pt-0" cols="12" v-if="showComponents('ChangeConfirmPerson', formData.in_journal_type)">
              <expand-form
                :showCards="showCards"
                name="ChangeConfirmPerson"
                :title="getConfirmPersonTitle"
              />
              <v-row v-show="showCards['ChangeConfirmPerson']">
                <v-col class="pb-0 pt-0" cols="6" v-if="!editStatus">
                  <el-autocomplete
                    direct
                    required
                    :items="confirmPersons"
                    itemvalue="value"
                    itemtext="text"
                    label="Patvirtinęs asmuo"
                    v-model="formData.change_confirm_person_id"
                    @change="toggleChangeConfirmPerson"
                  />
                </v-col>
                <v-col cols="4" v-if="!editStatus">
                  <el-button
                    class="mb-3"
                    small
                    color="primary"
                    icon="pridėti"
                    title="Pridėti kitą asmenį"
                    :loading="loading"
                    @click.native.stop="openAddConfirmPersonModal()"
                  />
                </v-col>
                <v-col cols="12" >
                  <el-simple-table :items="[
                    {
                      title: 'Patvirtinusio asmens pareigos, vardas ir pavardė',
                      value: (formData.change_confirm_person_position || '') + (formData.change_confirm_person_position ? ', ' : '') + (formData.change_confirm_person_fullname || ''),
                    },
                    {
                      title: 'Patvirtinusio asmens institucijos pavadinimas',
                      value: formData.change_confirm_person_institution || '',
                    },
                  ]" />
                </v-col>
              </v-row>
              <v-row>
               <v-col cols="12"><v-divider/></v-col>
              </v-row>
            </v-col>
            <!-- ErrorsCorrectionData -->
             <v-col class="pt-0" cols="12" v-if="showComponents('ErrorsCorrectionData', formData.in_journal_type)">
              <expand-form
                :showCards="showCards"
                name="ErrorsCorrectionData"
                title="Klaidos taisymo duomenys"
              />
              <v-row v-show="showCards['ErrorsCorrectionData']">
                <v-col class="pb-0 pt-0" cols="6" >
                     <el-text-field
                      label="Dokumento, patvirtinančio sprendimą ištaisyti duomenis, numeris"
                      :disabled="editStatus"
                      v-model="formData.change_notarial_no"
                      :maxlength="20"
                    />
                </v-col>
                   <v-col class="pb-0 pt-0" cols="6" >
                     <el-date-picker
                      :disabled="editStatus"
                      label="Dokumento, patvirtinančio sprendimą ištaisyti duomenis, data"
                      v-model="formData.change_confirm_date"
                  />
                </v-col> 
                <v-col class="pb-0 pt-0" cols="6" >
                  <el-autocomplete
                    direct
                    required
                    :disabled="editStatus"
                    :items="changeReasons"
                    itemvalue="value"
                    itemtext="text"
                    label="Klaidos taisymo pagrindas"
                    v-model="formData.change_reason_id"
                  />
                </v-col>
                <v-col class="pb-0 pt-0" cols="12" >
                  <el-textarea
                    required
                    label="Klaidos taisymo aprašymas"
                    v-model="formData.change_notes"
                    :disabled="editStatus"
                    :maxlength="1000"
                  />
                </v-col>
              </v-row>
              <v-row>
               <v-col cols="12"><v-divider/></v-col>
              </v-row>
            </v-col>
            <!-- Documents Form -->
            <v-col
              v-if="showComponents('Documents', formData.in_journal_type)"
              class="pt-0"
              cols="12"
              md="12"
            >
              <expand-form
                :showCards="showCards"
                name="Documents"
                title="Dokumentai"
              />
              <documents-form
                v-show="showCards['Documents']"
                :formData="formData"
                :onlyView="editStatus"
              />
              <v-divider class="mt-3"></v-divider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              :title="getBackTitle"
              @click.native.stop="beforeBack()"
              :loading="loading"
            />
            <el-button
              v-if="!editStatus"
              class="mr-1"
              title="Saugoti"
              icon="išsaugoti"
              :loading="loading"
              @click.native="beforeSave(false)"
              color="secondary"
            />
            <el-button
              v-if="canSendMessage"
              title="Pateikti"
              icon="išsaugoti"
              :loading="loading"
              @click.native="beforeSave(true)"
              color="primary"
            />
            <el-button
              v-if="canUnsubscribeBtn"
              title="Išregistruoti"
              color="danger"
              icon="atšaukti"
              :loading="loading"
              @click.native="beforeSave(true)"
            />
            <el-button
              v-if="canRegister"
              title="Įrašyti į registrą"
              icon="išsaugoti"
              :loading="loading"
              @click.native="beforeSave(true)"
              color="primary"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
     <!-- modals -->
     <modal-custom
      title="Pranešimo pateikimas"
      :text="showCheckDuplicates ? duplicateErrMsg : `Ar tikrai norite pateikti šį pranešimą? Po pateikimo nebus galima koreguoti šio pranešimo duomenų`"
      :trueText="showCheckDuplicates ? 'Siųsti nepaisant klaidos' : 'PATEIKTI'"
      falseText="ATŠAUKTI"
      :loading="loading"
      v-model="showModal"
      :mid="showCheckDuplicates"
      @confirmData="confirmSave"
      @closeModal="closeModal"
    />
    <modal-custom
      title="Pildymo atšaukimas"
      text="Duomenys nebus išsaugoti. Ar tikrai norite atšaukti duomenų pildymą?"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showCancelModal"
      @confirmData="confirmCancel"
    />
    <modal-add-confirm-person 
      v-if="showAddpersonModal" 
      @close-modal="closeAddPersonConfirmModal" 
    />
  </v-container>
</template>

<script>
import moment from 'moment'
import InJournalStatuses from '@/components/constants/inJournalStatus'
import InJournalTypes from '@/components/constants/inJournalTypes'
import MandateKinds from '@/components/constants/mandateKind'
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import Enums from '@/enums'
import MessageDetails from './MessageDetails.vue'
import DataProvider from './DataProvider.vue'
import DocumentsForm from './DocumentsForm.vue'
import PrincipalsForm from './PrincipalsForm.vue'
import RepresentitivesForm from './RepresentitivesForm.vue'
import MandateData from './MandateData.vue'
import MandateChangeData from './MandateChangeData.vue'
import ProvidedDataForm from './ProvidedDataForm.vue'
import RecognizedAsMissing from './RecognizedAsMissing.vue'
import ExpandForm from './ExpandForm.vue'
import ModalCustom from '@/components/modals/ModalCustom'
import ObjectList from './ObjectList.vue'
import Roles from '@/components/constants/roles'
import MandateKind from '@/components/constants/mandateKind'
import { showComponents, prepareDataToSave, store } from '@/services/noticeService.js'
import { classifiersGet, getFileSetting } from '@/services/classifierService.js'
import ModalAddConfirmPerson from '@/components/modals/ModalAddConfirmPerson.vue'

export default {
  name: 'MainMessageForm',
  components: {
    MessageDetails,
    DataProvider,
    DocumentsForm,
    PrincipalsForm,
    RepresentitivesForm,
    MandateData,
    MandateChangeData,
    ProvidedDataForm,
    RecognizedAsMissing,
    ExpandForm,
    ModalCustom,
    ObjectList,
    ModalAddConfirmPerson,
  },
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    mandateData: [Array, Object],
    createForm: Boolean,
  },
  data() {
    return {
      showCheckDuplicates: false,
      setForDuplicates: false,
      duplicateErrMsg: null,
      MandateKinds: MandateKinds,
      InJournalTypes: InJournalTypes,
      Roles: Roles,
      pageloading: false,
      loading: false,
      showCards: {},
      enumsClassifiers: {},
      listOfIntitutions: [],
      confirmPersons: [],
      changeReasons: [],
      formData: {
        documents:[
          { show_in_statement: false }
        ],
        mandates: [],
        person: {},
        mandate: {},
        institution: {},
        providedData: {},
        reauthorizedData: {},
      },
      // MODALS
      showModal: false,
      showCancelModal: false,
      showAddpersonModal: false,
    }
  },
  mounted() {
    this.fileTypes = sessionStorage.getItem('file_types')
    this.maxSize = sessionStorage.getItem('max_file_size')
    if (!this.fileTypes){
      getFileSetting();
    }
  },
  computed: {
    showSubdelegatedDetails(){
      return (this.showComponents('ObjectData', this.formData.in_journal_type) && this.formData.mandate.mandate_kind == MandateKind.NTPI) && (this.isSubmandate || this.formData.mandate.parent_id)
    },
    isSubmandateComp() {
      return this.isSubmandate || this.formData.mandate.parent_id
    },
    confirmPersonEditable() {
      return !this.editStatus && [InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA, InJournalTypes.PRANESIMAS_APIE_PAKEITIMA].includes(this.formData.in_journal_type)
    },
    isSubmandate() {
      return this.mandateData && this.mandateData.is_submandate
    },
    getConfirmPersonTitle() {
      return this.formData.in_journal_type == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA ? 'Įgaliojimo pasibaigimą patvirtino' : this.formData.in_journal_type == InJournalTypes.PRANESIMAS_APIE_PAKEITIMA ? 'Įgaliojimo pakeitimą patvirtino' : 'Įgaliojimą patvirtinusio notaro, konsulinio pareigūno ar kito asmens, turinčio teisę atlikti notarinius veiksmus, duomenys'
    },
    isErrorsCorrectionInaccuracies() {
      return this.formData.in_journal_type == InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS
    },
    isErrorsCorrectionWrongRegistered() {
      return this.formData.in_journal_type == InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA
    },
    isErrorsCorrection(){
      return this.isErrorsCorrectionInaccuracies || this.isErrorsCorrectionWrongRegistered
    },
    canSendMessage() {
      let hasRole = false;
      switch (this.formData.in_journal_type) {
        case InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA:
        case InJournalTypes.PRANESIMAS_APIE_PAKEITIMA:
          hasRole = this.hasRole([Roles.NOTARAS, Roles.KONSULAS, Roles.NOT_PAD2, Roles.KAL_VAD])
          break;
        case InJournalTypes.PRANESIMAS_APIE_PASIBAIGIMA:
        case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA:
          hasRole = this.hasRole([Roles.NOTARAS, Roles.KONSULAS, Roles.NOT_PAD2, Roles.KAL_VAD, Roles.TEISMAS, Roles.IR_REGISTRATORIUS, Roles.IR_ADMINISTRATORIUS, Roles.IR_KAC_DARBUOTOJAS, Roles.IR_RC_darbuotojas])
          break;
        case InJournalTypes.PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA:
        case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA:
        case InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMA:
        case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA:
        case InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA:
        case InJournalTypes.PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_PROKURA:
        case InJournalTypes.PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_IGALIOJIMAS:
        case InJournalTypes.PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_BENDRAS:
          hasRole = true;
          break;
      }
      return !this.editStatus && hasRole;
    },
    canUnsubscribeBtn() {
      return !this.editStatus && this.isErrorsCorrectionWrongRegistered;
    },
    canRegister() {
      return !this.editStatus && this.isErrorsCorrectionInaccuracies;
    },
    canEditContacts() {
      return (
          ([InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA, InJournalTypes.PRANESIMAS_APIE_PAKEITIMA].includes(this.formData.in_journal_type))
          || ([InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA].includes(this.formData.in_journal_type) && this.hasRole(Roles.NOTARINIU_GRUPE))
        ) && [InJournalStatuses.RENGIAMAS].includes(this.formData.status.toString())
    },
    allowForeignJur() {
      return [InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA, InJournalTypes.PRANESIMAS_APIE_PAKEITIMA].includes(this.formData.in_journal_type) 
    },
    getBackTitle() {
      return [InJournalStatuses.RENGIAMAS].includes(this.formData.status) ? 'Atšaukti' : 'Atgal'
    },
    allowAddPerson(){
      return [InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA, InJournalTypes.PRANESIMAS_APIE_PAKEITIMA, InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS].includes(this.formData.in_journal_type)
        && [InJournalStatuses.RENGIAMAS].includes(this.formData.status.toString())
    },
    selectedConfirmPerson() {
      return this.confirmPersons.filter(item => item.value == this.formData.mandate.confirm_person_id)[0] || [];
    },
    selectedChangeConfirmPerson() {
      return this.confirmPersons.filter(item => item.value == this.formData.change_confirm_person_id)[0] || [];
    },
    getInJournalName(){
      return this.formData?.in_journal_type ? (
        this.inJournalTypes[this.formData?.in_journal_type]
      ) : ''
    },
    getId() {
      return this.$route.params.id || null
    },
    editStatus(){
      return !(this.formData.status == "801" || this.formData.status == "807")
    },
    modeReadonly() {
      return false
    },
    getTitle() {
      return  this.editStatus ? this.$t(`Pranešimas`) : this.$t(`Naujas pranešimas`) 
    },
    getObjectDataTitle() {
      return this.formData.mandate.mandate_kind == MandateKinds.PP || this.formData.mandate.mandate_kind ==  MandateKinds.ITPSP 
                ? 'Prokūros duomenys'
                : ((this.formData.mandate.parent === null || this.formData.mandate.parent === undefined) ?  'Įgaliojimo duomenys' : 'Įgaliojimo, išduoto perįgaliojant, duomenys')
    },
    getPrincipalsTitle() {
      return this.formData.mandate.mandate_kind == MandateKinds.PP || this.formData.mandate.mandate_kind == MandateKinds.ITPSP ? 'Prokūrą išdavęs JA' : ((this.formData.mandate.parent === null || this.formData.mandate.parent === undefined) ? 'Įgaliotojai' : 'Perįgaliotojai')
    },
    getProvidedDataTitle() {
      switch (this.formData.in_journal_type) {
        case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA:
        case InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA:
          return 'Įgaliojimo pasibaigimo duomenys'
        case InJournalTypes.PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA:
          return 'Prokūros pasibaigimo duomenys'
        case InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMA:
          return 'Prokūros galiojimo sustabdymo duomenys'
        case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA:
          return 'Įgaliojimo galiojimo sustabdymo duomenys'
        case InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA:
          return 'Prokūros galiojimo sustabdymo panaikinimo duomenys'
        case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA:
          return 'Įgaliojimo galiojimo sustabdymo panaikinimo duomenys'
        default:
          return 'Kiti duomenys'
      }
    },
    getRepresentitivesTitle() {
      return this.formData.mandate.mandate_kind == MandateKinds.PP || this.formData.mandate.mandate_kind == MandateKinds.ITPSP ? 'Prokuristai' : ((this.formData.mandate.parent === null || this.formData.mandate.parent === undefined) ? 'Įgaliotiniai' : 'Perįgaliotiniai')
    },
    getPrincipals() {
      return this.formData.mandate.mandate_kind == MandateKinds.PP || this.formData.mandate.mandate_kind == MandateKinds.ITPSP ? this.formData.mandate.proPrincipals : this.formData.mandate.principals;
    },
    getRepresentitives() {
      return this.formData.mandate.mandate_kind == MandateKinds.PP || this.formData.mandate.mandate_kind == MandateKinds.ITPSP 
                      ? this.formData.mandate.procurators 
                      : (
                        (this.formData.mandate.parent === null || this.formData.mandate.parent === undefined) 
                          ? this.formData.mandate.representitives 
                          : this.formData.mandate.sub_representitives
                        )
    },
    getTableKey() {
      return this.formData.mandate.mandate_kind == MandateKinds.PP || this.formData.mandate.mandate_kind == MandateKinds.ITPSP ? 'procurators' : ((this.formData.mandate.parent === null || this.formData.mandate.parent === undefined) ? 'representitives' : 'sub_representitives')
    }
  },
  created() {
    this.getClassifiers()
    if(this.createForm){
      let isMandatePerson = false
      this.formData.data_provider_type = this.hasRole([Roles.IR_REGISTRATORIUS, Roles.TEISMAS, Roles.RC_DARBUOTOJAS, Roles.IR_KAC_DARBUOTOJAS, Roles.IR_ADMINISTRATORIUS, Roles.IR_RC_darbuotojas]) 
                                                ? 'court' 
                                                : (
                                                  this.hasRole([Roles.NOTARAS, Roles.NOT_PAD, Roles.NOT_PAD2])
                                                    ? 'notary'
                                                    : (this.hasRole([Roles.KAL_VAD])) 
                                                      ? 'prison'
                                                      : 'consul'
                                                )
      if(this.mandateData.in_journal_type == InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA){
        this.formData.in_journal_type = this.mandateData.in_journal_type
        if (this.mandateData.is_submandate) {
          this.formData.mandate = this.mandateData.mandate
          this.formData.mandate.cancelable = this.mandateData.mandate.cancelable ? "0" : "1"
          this.formData.mandate.confirm_date = ''
          this.formData.mandate.notarial_no = ''
          this.formData.mandate.form_place = ''
          this.formData.mandate.confirm_person_fullname = ''
          this.formData.mandate.confirm_person_position = ''
          this.formData.mandate.confirm_person_institution = ''
          this.formData.mandate.confirm_person_id = ''
          this.formData.mandate.parent = JSON.parse(JSON.stringify(this.mandateData.mandate));
          this.formData.mandate.parent_id = this.formData.mandate.id
          if (this.mandateData.in_journal_type == InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA) {
            this.formData.mandate.mandate_code = ''
          }
          this.formData.mandate.principals_together = this.mandateData.mandate.parent.parent_id ? this.mandateData.mandate.sub_representitives_together : this.mandateData.mandate.representitives_together
          this.formData.mandate.principals = this.mandateData.mandate.parent.parent_id ? this.mandateData.mandate.sub_representitives : this.mandateData.mandate.representitives
          this.formData.mandate.representitives = [];
          this.formData.mandate.sub_representitives = [];
          isMandatePerson = true
        } else {
          this.formData.id = this.mandateData.id
          this.formData.mandate = {mandate_kind: MandateKind.NTPI, principals: [], representitives: [], sub_representitives: [], parent: null}
        }
        this.formData.request_date = moment().format('YYYY-MM-DD')
        this.formData.status = InJournalStatuses.RENGIAMAS
      } else {
        if (this.mandateData.in_journal_type == InJournalTypes.PRANESIMAS_APIE_PAKEITIMA) {
          isMandatePerson = true
        }
        if (this.mandateData.in_journal_type != InJournalTypes.PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_BENDRAS) {
          this.formData.documents = this.mandateData.mandate.original_attachments
          this.formData.mandate = this.mandateData.mandate
          this.formData.mandate.cancelable = this.mandateData.mandate.cancelable ? "0" : "1"
        }
        this.formData.in_journal_type = this.mandateData.in_journal_type
        this.formData.request_date = moment().format('YYYY-MM-DD')
        this.formData.status = InJournalStatuses.RENGIAMAS
        this.formData.person = this.mandateData.person
        this.formData.person_amn_id = this.mandateData.person_amn_id
        this.formData.mandates = this.mandateData.mandates
      }

      if (isMandatePerson) {
         for (const personType of ['principals', 'representitives', 'sub_representitives']) {
          if (this.formData.mandate[personType]) {
            this.formData.mandate[personType].map((person, key) => {
              this.formData.mandate[personType][key].id = ''
              this.formData.mandate[personType][key].mandate_person_id = this.formData.mandate[personType][key].amn_id.includes('new_id') && this.formData.mandate[personType][key].amn_id != 'new_id' ? this.formData.mandate[personType][key].amn_id.replace('new_id', '')  : ''
            })
          }
        }
      }
      if (this.hasRole([Roles.IR_REGISTRATORIUS]) && !this.isErrorsCorrection) {
        this.$set(this.formData, 'institution', {})
      } else {
        this.getUserInstitution()
      }
    } else {
      this.formData.id = this.$route.params.id;
      this.getData()
    } 
  },
  methods: {
    showComponents,
    setDataProvider(institution){
      this.$set(this.formData,'institution', institution)
    },
    openAddConfirmPersonModal() {
      this.showAddpersonModal = true;
    },
    closeAddPersonConfirmModal(update) {
      if(update){
        this.reloadAuthPersons()
      }
      this.showAddpersonModal = false;
    },
    toggleChangeConfirmPerson() {
      this.formData.change_confirm_person_fullname = this.selectedChangeConfirmPerson.longname
      this.formData.change_confirm_person_position = this.selectedChangeConfirmPerson.position
      this.formData.change_confirm_person_institution = this.selectedChangeConfirmPerson.organisation
    },
    toggleConfirmPerson() {
      this.formData.mandate.confirm_person_fullname = this.selectedConfirmPerson.longname
      this.formData.mandate.confirm_person_position = this.selectedConfirmPerson.position
      this.formData.mandate.confirm_person_institution = this.selectedConfirmPerson.organisation
    },
    addConfirmPerson() {
      this.showAddpersonModal = false;
    },
    confirmCancel(){
      this.back()
    },
    beforeBack(){
      if ([InJournalStatuses.RENGIAMAS].includes(this.formData.status)) {
        this.showCancelModal = true
      } else {
        this.back()
      }
    },
    hasRole(roles) {
      const userRole = this.$store.getters.userRole
      return roles.some((item) => {
        return userRole.includes(item)
      })
    },
    getClassifiers() {
      this.inJournalTypes = Enums.inJournalType.lt
      this.reloadAuthPersons()
      classifiersGet({ classifiers: ['expiration-reason']})
        .then(res => this.changeReasons = res.data.classifiers['expiration-reason'].lt)
        .catch(err => this.$root.$emit('DATA_ERROR', err))
        .finally()
    },
    reloadAuthPersons() {
      classifiersGet({ classifiers: ['authorizing-person'] })
        .then(res => this.confirmPersons = res.data.classifiers['authorizing-person'].lt)
        .catch(err => this.$root.$emit('DATA_ERROR', err))
        .finally()
    },
    getUserInstitution() {
      let url = `user-institution-data`
      this.$axios
        .get(url)
        .then((res) => this.setInstitution(res.data))
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    back() {
      if(this.isErrorsCorrectionInaccuracies || this.isErrorsCorrectionWrongRegistered) {
        this.$router.push({ name: 'errorsCorrectionList' })
      } else {
        this.$router.push({ name: 'adminMessagesPreparedSent' })
      }
    },
    expandAll() {
      Object.keys(this.showCards).map((key) => {
        this.$set(this.showCards, key, true)
      })
    },
    beforeSave(validate) {
        this.$validator.validateAll().then((res) => {
          if (res) {
            this.$set(this.formData, 'action', validate ? 'send' : 'save')
            if(validate){
              this.showModal = true
            } else {
              this.saveData()
            }
          } else {
            this.expandAll()
            this.$root.$emit('FORMAT_ERROR')
          }
        })
    },
    getData() {
      this.pageloading = true
      let url = `in-journals/${this.getId}/request`
      if(this.$route.name == "errorsCorrectionNew"){
        url = `in-journals/official-notices/${this.getId}`
      }
      this.$axios
        .get(url)
        .then((res) => {
          this.$set(this.formData, 'id', res.data.inJournal.id || "")
          this.$set(this.formData, 'request_number', res.data.inJournal.request_number || "")
          this.$set(this.formData, 'request_date', res.data.inJournal.request_date || "")
          this.$set(this.formData, 'documents', res.data.inJournal.documents || "")
          this.$set(this.formData, 'status', res.data.inJournal.status || "")
          this.$set(this.formData, 'in_journal_type', res.data.inJournal.in_journal_type || "") 
          this.$set(this.formData, 'data_provider_other_info', res.data.inJournal.data_provider_other_info || "")
          this.$set(this.formData, 'data_provider_amn_id', res.data.inJournal.data_provider.amn_id || "")
          this.$set(this.formData, 'data_provider_type', res.data.inJournal.data_provider_type || "")
          this.$set(this.formData, 'institution', res.data.inJournal.data_provider || "")
          this.$set(this.formData.institution, 'data_provider_amn_id', res.data.inJournal.data_provider.amn_id)
          this.$set(this.formData.institution, 'change_reason_id', res.data.inJournal.change_reason_id)
          this.$set(this.formData.institution, 'representitive_amn_id', res.data.inJournal.data_provider.representitive_amn_id)
          this.$set(this.formData, 'providedData', {})
          this.$set(this.formData.providedData, 'change_notarial_no', res.data.inJournal.change_notarial_no || "")
          this.$set(this.formData.providedData, 'basis_date', res.data.inJournal.basis_date || "")
          this.$set(this.formData.providedData, 'court_id', res.data.inJournal.court_id || "")
          this.$set(this.formData.providedData, 'court_name', res.data.inJournal.court_name || "")
          this.$set(this.formData.providedData, 'court_decision_date', res.data.inJournal.decision_date || "")
          this.$set(this.formData.providedData, 'decision_number', res.data.inJournal.decision_number || "")
          this.$set(this.formData.providedData, 'expiration_reason_id', res.data.inJournal.expiration_reason_id || "")
          this.$set(this.formData.providedData, 'expiration_reason_text', res.data.inJournal.expiration_reason_text || "")
          this.$set(this.formData.providedData, 'expiration_reason_description', res.data.inJournal.expiration_reason_description || "")
          this.$set(this.formData.providedData, 'suspension_reason_id', res.data.inJournal.suspension_reason_id || "")
          this.$set(this.formData.providedData, 'suspension_reason_text', res.data.inJournal.suspension_reason_text || "")
          this.$set(this.formData.providedData, 'suspension_reason_description', res.data.inJournal.suspension_reason_description || "")
          this.$set(this.formData, 'mandate', res.data.inJournal.mandate || {});

          if (res.data.inJournal.mandate) {
            this.$set(this.formData.mandate, 'mandate_kind', res.data.inJournal.mandate.kind || "")
            this.$set(this.formData.mandate, 'proPrincipals', res.data.inJournal.mandate.pro_principals, {})
            this.$set(this.formData.mandate, 'confirm_person_id', res.data.inJournal.mandate.confirm_person_id);
            this.$set(this.formData.mandate, 'cancelable', res.data.inJournal.mandate.cancelable ? '0' : '1');
          }

          if (res.data.inJournal.in_journal_type == InJournalTypes.PRANESIMAS_APIE_PAKEITIMA) {
            this.$set(this.formData, 'change_confirm_date', res.data.inJournal.change_confirm_date || "");
            this.$set(this.formData, 'change_reason_id', res.data.inJournal.change_reason_id || "");
            this.$set(this.formData, 'change_reason_lt', res.data.inJournal.change_reason_lt || "");
            this.$set(this.formData, 'change_notarial_no', res.data.inJournal.change_notarial_no || "");
            this.$set(this.formData, 'notarial_person_number', res.data.inJournal.notarial_person_number || "");
            this.$set(this.formData, 'change_notes', res.data.inJournal.change_notes || "");
            this.$set(this.formData, 'change_confirm_person_id', res.data.inJournal.change_confirm_person_id || "");
            this.$set(this.formData, 'change_confirm_person_fullname', res.data.inJournal.change_confirm_person_fullname || "");
            this.$set(this.formData, 'change_confirm_person_position', res.data.inJournal.change_confirm_person_position || "");
            this.$set(this.formData, 'change_confirm_person_institution', res.data.inJournal.change_confirm_person_institution || "");
          }

          if (res.data.inJournal.in_journal_type == InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS) {
            this.$set(this.formData, 'change_confirm_date', res.data.inJournal.change_confirm_date || ""); 
            this.$set(this.formData, 'change_reason_id', res.data.inJournal.change_reason_id || "");
            this.$set(this.formData, 'change_reason_lt', res.data.inJournal.change_reason_lt || "");
            this.$set(this.formData, 'change_notarial_no', res.data.inJournal.change_notarial_no || ""); 
            this.$set(this.formData, 'notarial_person_number', res.data.inJournal.notarial_person_number || "");
            this.$set(this.formData, 'change_notes', res.data.inJournal.change_notes || ""); 
          }

          if (res.data.inJournal.in_journal_type == InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA) {
            this.$set(this.formData.providedData, 'change_notarial_no', res.data.inJournal.change_notarial_no || "");
            this.$set(this.formData.providedData, 'notarial_person_number', res.data.inJournal.notarial_person_number || "");
            this.$set(this.formData, 'change_confirm_person_id', res.data.inJournal.change_confirm_person_id);
            this.$set(this.formData, 'change_confirm_person_fullname', res.data.inJournal.change_confirm_person_fullname || "");
            this.$set(this.formData, 'change_confirm_person_position', res.data.inJournal.change_confirm_person_position || "");
            this.$set(this.formData, 'change_confirm_person_institution', res.data.inJournal.change_confirm_person_institution || "");
          }

          if (res.data.inJournal.in_journal_type == InJournalTypes.PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_BENDRAS) {
            this.$set(this.formData, 'mandates', res.data.inJournal.mandates)
            this.$set(this.formData, 'person', {});
            this.$set(this.formData.person, 'searchType', res.data.inJournal.search_type);
            this.$set(this.formData.person, 'name', res.data.inJournal.person_name);
            this.$set(this.formData.person, 'lastname', res.data.inJournal.person_lastname);
            this.$set(this.formData.person, 'code', res.data.inJournal.person_code);
            this.$set(this.formData, 'person_amn_id', res.data.inJournal.person_amn_id);
          }
          if (!res.data.inJournal.data_provider.amn_id) {
            this.getUserInstitution()
          }
        })
        .catch((err) => {
          if (err.response.status === 404) {
            return this.$router.push({ name: 'sav404' })
          } else {
            this.$root.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    closeModal(){
      if(this.showCheckDuplicates){
        this.setForDuplicates = false
        this.showCheckDuplicates = false
      }
    },
    confirmSave(){
      if(this.showCheckDuplicates){
        this.setForDuplicates = true
      }
      this.saveData()
    },
    setInstitution(data) {
      switch (this.formData.in_journal_type) {
        case InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA:
        case InJournalTypes.PRANESIMAS_APIE_PAKEITIMA:
        case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA:
        case InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS:
        case InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA:
          if (data.institution) {
            this.$set(this.formData, 'institution', data.institution);
            this.$set(this.formData.providedData, 'court_name', data.institution.fullname)
            this.$set(this.formData.providedData, 'court_id', data.institution.amn_id)
            this.$set(this.formData, 'data_provider_amn_id', data.institution.amn_id)
          } else {
            if (data.institutions.length > 1) {
              this.listOfIntitutions = data.institutions;
            } else if (data.institutions.length === 1) {
              this.setDataProvider(data.institutions[0])
            }
          }
          break;

        default: 
          if (this.hasRole([Roles.TEISMAS])) {
            this.$set(this.formData, 'institution', data.institution);
            this.$set(this.formData.providedData, 'court_name', data.institution.fullname)
            this.$set(this.formData.providedData, 'court_id', data.institution.amn_id)
            this.$set(this.formData, 'data_provider_amn_id', data.institution.amn_id)
          } else {
            if (!this.formData.institution) {
              this.$set(this.formData, 'institution', data.institution);
              this.$set(this.formData.providedData, 'court_name', data.institution.fullname)
              this.$set(this.formData.providedData, 'court_id', data.institution.amn_id)
            }
            if (!this.formData.data_provider_amn_id) {
              this.$set(this.formData, 'data_provider_amn_id', data.institution.amn_id)
            }
        }
          }
    },
    saveData() {
      this.loading = true
      if(this.setForDuplicates){
        this.$set(this.formData, 'check_duplicates', 0)
      } else {
        this.$set(this.formData, 'check_duplicates', 1)
      }
      let preparedData = prepareDataToSave(this.formData);
      if ((preparedData['emitError'] || undefined) === undefined) {
        store(preparedData['formData'], this.formData.id, this.isErrorsCorrection)
          .then((res) => {
            if(this.isErrorsCorrection){
              this.$router.push({name: 'errorsCorrectionList'})
            } else {
              this.$router.push({name: 'adminMessagesPreparedSent'})
            }
          })
          .catch((err) => {
            if (err.response.status == 409) {
                this.showCheckDuplicates = true
                this.duplicateErrMsg = err.response.data.errors[0]
            } else {
              this.$root.$emit('DATA_ERROR', err)
            }
          })
          .finally(() => {
            this.setForDuplicates = false
            this.loading = false
          })
      } else {
        if (preparedData['emitError'] === 'DATA_ERROR_TEXT') {
          this.$root.$emit(preparedData['emitError'], preparedData['emitText'])
        } else if (preparedData['emitError'] === 'DATA_ERROR_CODE') {
          this.$root.$emit(preparedData['emitError'], preparedData['emitText'][0])
        } else {
          this.$root.$emit(preparedData['emitError'])
        }
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
